import { render } from "./SetCategories.vue?vue&type=template&id=3dde5b75&scoped=true"
import script from "./SetCategories.vue?vue&type=script&lang=js"
export * from "./SetCategories.vue?vue&type=script&lang=js"

import "./SetCategories.vue?vue&type=style&index=0&id=3dde5b75&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dde5b75"]])

export default __exports__